<template>
  <form class="space-y-2" @submit.prevent="() => {}">
    <template v-if="mode === 'multiple'">
      <div v-for="integration in userIntegrations" :key="integration.id">
        <div v-if="integration?.data?.organizations?.length" class="space-y-2">
          <OrganizationPickerCheckboxOption
            v-for="org in integration.data.organizations"
            :key="org.id"
            v-model="selectedOptions[org.id]"
            :user-organizations="org"
            :platform="platform"
            @update:model-value="onUpdate"
          />
        </div>
      </div>
    </template>
  </form>
</template>

<script
  setup
  lang="ts"
  generic="Mode extends 'single' | 'multiple' = 'single' | 'multiple'"
>
import type { IUserIntegration } from "@/types/account";
import OrganizationPickerCheckboxOption from "./OrganizationPickerCheckboxOption.vue";

const props = defineProps<{
  mode: Mode;
  userIntegrations: IUserIntegration<"linkedin">[];
  platform: "linkedin";
  modelValue: Mode extends "single" ? string : string[];
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: Mode extends "single" ? string : string[]): void;
}>();

// Initialize the selectedOptions
const selectedOptions = reactive<Record<string, boolean>>({});

function onUpdate() {
  if (props.mode === "multiple") {
    const selected = Object.entries(selectedOptions)
      .filter(([_, selected]) => selected)
      .map(([id]) => id);

    // @ts-ignore
    emit("update:modelValue", selected);
  }
}
</script>
